<template>
    <Modal ref="modal" class="order-history-order-updated-details-modal">
        <template #button="sp">
            <button class="btn btn-sm btn-outline-secondary" @click="sp.showModal">
                <i class="fad fa-fw fa-eye"></i> Détails
            </button>
        </template>
        <template #header>
            <div class="h3">Détails des changements</div>
        </template>
        <template #body="sp">
            <div v-if="diff.customer">
                <span class="h4">{{ order.customer_label }}</span>
                <p>
                    Avant : {{ diff.customer.old }}<br>
                    Après : {{ diff.customer.new }}
                </p>
            </div>
            <div v-if="diff.subcustomer_name">
                <span class="h4">{{ order.final_customer_label }}</span>
                <p>
                    Avant : {{ diff.subcustomer_name.old }}<br>
                    Après : {{ diff.subcustomer_name.new }}
                </p>
            </div>
            <div v-if="diff.subcustomer_phone">
                <span class="h4">Téléphone</span>
                <p>
                    Avant : {{ diff.subcustomer_phone.old }}<br>
                    Après : {{ diff.subcustomer_phone.new }}
                </p>
            </div>
            <div v-if="diff.subcustomer_email">
                <span class="h4">E-mail</span>
                <p>
                    Avant : {{ diff.subcustomer_email.old }}<br>
                    Après : {{ diff.subcustomer_email.new }}
                </p>
            </div>
            <div v-if="diff.deliveryDate">
                <span class="h4">Date de livraison</span>
                <p>
                    Avant : {{ formatDate(diff.deliveryDate.old) }}<br>
                    Après : {{ formatDate(diff.deliveryDate.new) }}
                </p>
            </div>
            <div v-if="diff.endPreparationDate">
                <span class="h4">Date de fin de préparation</span>
                <p>
                    Avant : {{ formatDate(diff.endPreparationDate.old) }}<br>
                    Après : {{ formatDate(diff.endPreparationDate.new) }}
                </p>
            </div>
            <div v-if="diff.closingDate">
                <span class="h4">Date de fermeture des commandes</span>
                <p>
                    Avant : {{ formatDate(diff.closingDate.old) }}<br>
                    Après : {{ formatDate(diff.closingDate.new) }}
                </p>
            </div>
            <div v-if="diff.products">
                <span class="h4">Changements sur les produits</span>

                <table class="table table-striped table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Avant</th>
                            <th scope="col">Après</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="unchanged in diff.products.unchanged">
                            <th scope="row">{{ unchanged.name }}</th>
                            <td>
                                {{ unchanged.quantity }}
                                <template v-if="unchanged.quantityOffered">
                                    ({{ unchanged.quantityOffered }} <i class="fas fa-gift"></i>)
                                </template>
                            </td>
                            <td>
                                {{ unchanged.quantity }}
                                <template v-if="unchanged.quantityOffered">
                                    ({{ unchanged.quantityOffered }} <i class="fas fa-gift"></i>)
                                </template>
                            </td>
                        </tr>
                        <tr v-for="added in diff.products.added" class="table-success">
                            <th scope="row">{{ added.name }}</th>
                            <td>-</td>
                            <td>
                                {{ added.quantity }}
                                <template v-if="added.quantityOffered">
                                    ({{ added.quantityOffered }} <i class="fas fa-gift"></i>)
                                </template>
                            </td>
                        </tr>
                        <tr v-for="updated in diff.products.updated" class="table-warning">
                            <th scope="row">{{ updated.name }}</th>
                            <td>
                                {{ updated.quantityBefore }}
                                <template v-if="updated.quantityOfferedBefore">
                                    ({{ updated.quantityOfferedBefore }} <i class="fas fa-gift"></i>)
                                </template>
                            </td>
                            <td>
                                {{ updated.quantityAfter }}
                                <template v-if="updated.quantityOfferedAfter">
                                    ({{ updated.quantityOfferedAfter }} <i class="fas fa-gift"></i>)
                                </template>
                            </td>
                        </tr>
                        <tr v-for="removed in diff.products.removed" class="table-danger">
                            <th scope="row">{{ removed.name }}</th>
                            <td>
                                {{ removed.quantity }}
                                <template v-if="removed.quantityOffered">
                                    ({{ removed.quantityOffered }} <i class="fas fa-gift"></i>)
                                </template>
                            </td>
                            <td>-</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template #footer="sp">
            <button class="btn btn-secondary" @click="sp.closeModal()">Fermer</button>
        </template>
    </Modal>
</template>

<script>
import Modal from './Modal';
import {momentDay} from "../moment-with-helpers"

export default {
    name: 'OrderHistoryOrderUpdatedDetailsModal',

    components: {
        Modal,
    },

    props: {
        order: {
            type: Object,
            required: true,
        },
        diff: {
            type: Object,
            required: true,
        },
    },

    methods: {
        formatDate(date) {
            return momentDay(date).format('dddd D MMMM Y');
        }
    },
}
</script>

<style lang="scss">
    .order-history-order-updated-details-modal {
        .modal-container {
            max-width: 600px!important;
            width: auto;
        }
    }
</style>
